import { message } from "antd";

// Global click-to-dismiss for antd notification/message toasts, wired once
// at the app root instead of at each of the 90+ notification/message call
// sites scattered across the app. Works regardless of whether a call site
// used the static antd API or App.useApp()'s context-scoped instance —
// both render into the same DOM structure, so this only needs to know the
// class names, not who constructed the notice.
export function handleDismissibleNotificationClick(target) {
  if (!target?.closest) return;

  const notice = target.closest(".ant-notification-notice");
  if (notice) {
    // Mail remains until an explicit Open/Dismiss/close action. Clicking its
    // text must not silently dismiss an unacknowledged persistent notice.
    if (notice.classList.contains('srm-notification--mail')) return;
    // The close button's own click handler already closes it — clicking it
    // again here would be a redundant no-op at best.
    if (target.closest(".ant-notification-notice-close")) return;
    notice.querySelector(".ant-notification-notice-close")?.click();
    return;
  }

  if (target.closest(".ant-message-notice")) {
    // message toasts have no per-instance close control, and this app never
    // creates them through App.useApp().message (always the static import),
    // so destroy() reliably clears whatever's currently showing.
    message.destroy();
  }
}
